import { useEffect, useState } from "react"
import { Button, Col, Form, Row, Spinner } from "react-bootstrap"
import http from "../helpers/Request"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { useSearchParams } from "react-router-dom"

const MySwal = withReactContent(Swal)

function DemoForm() {
  const [searchParams] = useSearchParams()
  const productSelected = searchParams.get('product')
  const [form, setForm] = useState({
    fullname: '',
    phone: '',
    email: '',
    company: '',
    title: '',
    message: '',
    selected_package: ''
  })
  const [products, setProducts] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(false)
  const [checkbox, setCheckbox] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) => {

    e.preventDefault();

    if(!form.selected_package){
      MySwal.fire({
        title: 'Error',
        text: 'Please select product',
        icon: 'error'
      })
      
      return false
    }

    setLoading(true)
    
    http.post('/api/contact', {
      full_name: form.fullname,
      mobile_phone: form.phone,
      business_email: form.email,
      company: form.company,
      job_title: form.title,
      selected_package: '',
      message: form.message,
      marketing_opt_in: checkbox ? 1 : 0,
      selected_package: form.selected_package
    }).then(res => {
      MySwal.fire({
        title: 'Success',
        text: 'Thank for you for your response, we will contacting you',
        icon: 'success'
      })

      setForm({
        fullname: '',
        phone: '',
        email: '',
        company: '',
        title: '',
        message: '',
        selected_package: ''
      })
      setCheckbox(false);
    }).catch(err => {
       MySwal.fire({
          title: 'Error',
          text: 'Something went wrong...',
          icon: 'error'
        })
    }).finally(() => {
      setLoading(false)
    })
  };

  useEffect(() => {
    if(productSelected){
      setForm(state => ({...state, selected_package: productSelected}))
    }
  }, [productSelected])

  useEffect(() => {
    const fetchProducts = async () => {
      setLoadingProducts(true)
      try {
        const res = await http.get('/api/products')
        const list = res?.data?.data || res?.data || []
        setProducts(Array.isArray(list.data) ? list.data : list)
      } catch (err) {
        // fallback to defaults if needed
        setProducts([])
      } finally {
        setLoadingProducts(false)
      }
    }
    fetchProducts()
  }, [])

  return(
    <div className='card-shadow'>
      <Row className='category request-form'>
        <Col xs={12} md={6}>
          <div className="desc">
            <div className='title mb-4'>Your Future Is in the Cloud Let’s Secure It Together</div>
            <p>Cyber threats are evolving. Your business can’t afford blind spots.</p>
            <p>Siberwander helps you stay ahead with agentless cloud security, designed to be fast to deploy, easy to manage, and powerful at scale so your team can focus on growing your business, not chasing alerts.</p>
            <p>Whether you're protecting sensitive data, preparing for audits, or building a secure foundation for growth, we’ve got your cloud covered.</p>
            <h3 className='title mt-4'>Get Started from $2,000<br/>Includes a 7-Day Free Trial</h3>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className='form'>
            <div className='text-center'><strong>Request a Demo of</strong></div>
            <div className='text-center'><strong>Siberwander Security Platform</strong></div>
            <Form className="mt-4" onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold mb-0">Full Name<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Full Name"
                  value={form.fullname}
                  onChange={(event) => setForm(state => ({...state, fullname: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Mobile Phone<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Mobile Phone"
                  value={form.phone}
                  onChange={(event) => setForm(state => ({...state, phone: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Business Email<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Business Email"
                  value={form.email}
                  onChange={(event) => setForm(state => ({...state, email: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Company/Org<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Company/Org"
                  value={form.company}
                  onChange={(event) => setForm(state => ({...state, company: event.target.value}))}
                  disabled={loading}
                  required
                />
                <Form.Label className="fw-semibold mb-0 mt-2">Job Title<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Job Title"
                  value={form.title}
                  onChange={(event) => setForm(state => ({...state, title: event.target.value}))}
                  disabled={loading}
                  required
                />

                <Form.Label className="fw-semibold mb-0 mt-2">Select Product<span className="text-danger">*</span></Form.Label>
                <Form.Select 
                  defaultValue={form.selected_package}
                  value={form.selected_package}
                  required
                  onChange={(event) => setForm(state => ({...state, selected_package: event.target.value}))}
                  disabled={productSelected}
                >
                  <option value="" disabled hidden>
                    {loadingProducts ? 'Loading products...' : 'Select Product'}
                  </option>
                  {products.map((p) => (
                    <option key={p.id || p.name} value={p.name}>
                      {p.name}
                    </option>
                  ))}
                </Form.Select>

                <Form.Label className="fw-semibold mb-0 mt-2">Message<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Message"
                  value={form.message}
                  onChange={(event) => setForm(state => ({...state, message: event.target.value}))}
                  disabled={loading}
                  rows={4}
                />
                
                <div className="d-flex flex-row gap-3 mt-2">
                  <Form.Check
                    type={'checkbox'}
                    checked={checkbox}
                    readOnly
                    onClick={()=>setCheckbox(!checkbox)}
                  />
                  <p className="text-justify">By checking this box, I consent to receive Insight marketing emails. We respect your privacy and will not share your personal information with any other company, person or identity.</p>
                </div>
                <Form.Group className="mb-3 mt-4">
                  <Button variant="brand" disabled={loading||!checkbox} style={{width:'100%'}} type="submit">
                    {
                      loading?(
                        <>
                          <Spinner animation="border" size="sm" className="me-2"/> Loading
                        </>
                      ):(
                        <>Submit</>
                      )
                    }
                  </Button>
                </Form.Group>
              </Form.Group>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default DemoForm
